<template>
  <div v-if="!loading && haveAccount && !loadTranslation">
    <AppSidebar ref="sidebar" @burger-toggle="burgerClose"></AppSidebar>

    <section class="mobile-header">
      <img v-if="whitelabel" :src="orgLogo" class="orgLogo" />
      <a v-else class="logo" href="/dashboard">
        <svg viewBox="0 0 336.85 76.07">
          <g fill="#FFF">
            <path
              d="M331.39 27.06h-4.02v.83h1.51v3.63h1V27.9h1.5v-.83zm4.52 0l-1.54 2.32-1.53-2.32h-.94v4.46h.93v-3.05l1.36 2.07h.37l1.36-2.08v3.06h.93v-4.46h-.94zM241.8 18.17c0-2.88-2.29-5.15-5.13-5.15s-5.13 2.28-5.13 5.15c0 2.83 2.3 5.15 5.13 5.15s5.14-2.32 5.14-5.15zM315.2 27.06l-8.84 23.72-8.5-23.72h-10.77l13.82 31.5a89.98 89.98 0 0 1-5.85 10.7l9.7 2.59c6.85-11.83 13.82-27.58 21-44.79h-10.57zM256.32 43.54v-.6c0-5.51 2.99-8.64 8.84-8.64 3.59 0 6.51.87 8.57 2.8v11.42c-2.13 1.93-4.58 2.93-8.64 2.93-5.51 0-8.77-2.66-8.77-7.91zm27.84 15.08c-.33-1.52-.53-4.58-.53-9.5V10.65h-9.9v18.67c-1.86-1.53-5.51-2.92-9.43-2.92-9.97 0-17.88 5.58-17.88 16.74v.8c0 10.23 7.9 15.28 16.35 15.28 5.91 0 9.57-2.26 11.56-4.32.13 1.2.4 2.73.8 3.72h9.03zM241.62 27.06h-9.9v31.56h9.9V27.06zM222.17 26.73c-4.46 0-7.51 2.66-8.77 7.57l-.54-7.24h-9.17v31.56h9.84V40.75c1.13-2.92 3.65-5.12 6.9-5.12 2 0 3.66.53 4.86 1.33l1.6-9.3c-1-.53-3.13-.93-4.72-.93zM172.13 48.72c0-2.85 2.4-3.65 7.04-3.65 3.13 0 6.12.53 8.44 1.33v3.19c-1.8 1.72-5.18 2.59-8.7 2.59-3.66 0-6.78-.53-6.78-3.46zm25.05 9.9c-.46-1.52-.66-3.52-.66-8.37 0-3.06.06-6.58.13-9.7.2-10.23-6.91-14.15-16.48-14.15a40.37 40.37 0 0 0-14.48 2.46l2.45 7.7c2.13-1.6 6.05-2.72 10.64-2.72 5.31 0 9.03 1.2 8.97 5.78l-.07 1.2a29.32 29.32 0 0 0-10.63-2.07c-7.9 0-14.22 2.46-14.22 10.37 0 7.24 6.78 10.1 13.55 10.1 6.45 0 9.84-2.13 11.63-3.99.2 1.13.47 2.4.73 3.4h8.44zM143.69 26.4c-5.65 0-9.37 2.32-11.23 4.58V10.65h-10.17v47.97h10.1V38.56c1.73-2.2 4.19-3.66 8.1-3.66 4.93 0 7.05 2.33 7.05 7.51v16.21h10.17v-16.8c0-9.71-4.78-15.42-14.02-15.42zM102.63 26.4c-10.97 0-18.74 6.38-18.74 16.4v.74c0 10.23 7.1 15.68 18.87 15.68 5.91 0 11.63-1.66 14.95-4.32l-3.59-7.5c-2.26 2.19-6.58 3.98-10.76 3.98-6.52 0-9.57-2.99-9.57-8.17v-.73c0-5.19 3.99-8.11 9.5-8.11 4.65 0 8.04.93 10.5 3.12l3.79-7.44c-3.73-2.32-8.77-3.65-14.95-3.65zM38.04 0c10.5 0 20 4.26 26.9 11.14a37.92 37.92 0 0 1 11.13 26.9c0 10.5-4.25 20.01-11.14 26.9-6.88 6.88-16.39 11.13-26.9 11.13s-20-4.25-26.89-11.14S0 48.54 0 38.03v-.38a37.92 37.92 0 0 1 11.14-26.5A37.92 37.92 0 0 1 38.04 0zM17.06 35.41a12.13 12.13 0 0 1 20.96-4.8c.2-.23.42-.45.63-.67a12.12 12.12 0 0 1 12.23-3.01 23.95 23.95 0 0 0-21.16-12.78c-6.6 0-12.57 2.67-16.89 7a23.8 23.8 0 0 0-7 16.57v.32c0 8.89 3.6 16.94 9.44 22.77a32.1 32.1 0 0 0 22.77 9.43c8.89 0 16.94-3.6 22.77-9.43a32.1 32.1 0 0 0 9.43-22.77c0-8.9-3.6-16.95-9.43-22.77a32.1 32.1 0 0 0-22.77-9.44c-4.79 0-9.33 1.05-13.41 2.92a29.63 29.63 0 0 1 26.11 8.27 29.63 29.63 0 0 1 8.69 20.07 21.45 21.45 0 0 1-21.4 22.34c-5.9 0-11.25-2.4-15.12-6.27a21.32 21.32 0 0 1-6.24-14.05c-.06-1.26.07-2.48.39-3.7zm36.53 3.04a6.32 6.32 0 0 0-10.81-4.39l-4.77 4.48-4.83-4.58a6.34 6.34 0 0 0-10.7 4.17 15.5 15.5 0 0 0 4.56 10.9 15.5 15.5 0 0 0 22 0 15.5 15.5 0 0 0 4.55-10.58z"
            />
          </g>
        </svg>
      </a>
    </section>

    <div @click="sidebarToggle" role="button" class="burger" :class="{ open: isBurgerOpen }">
      <div class="burger__bar"></div>
      <div class="burger__bar"></div>
      <div class="burger__bar"></div>
    </div>

    <my-top-curved-bg />

    <div class="wrapper-home" v-if="!loadingAccess">
      <transition name="fade">
        <router-view></router-view>
      </transition>
      <SmartupIframe />
    </div>
  </div>

  <div v-else-if="needSelectOrg" class="select-organizations-wrapper">
    <AppSidebar :need-select-org="needSelectOrg" ref="sidebar" @burger-toggle="burgerClose" />

    <div class="select-organizations" v-if="organizations.length > 0">
      <h4>
        {{ $t("template.select_organization") }}
      </h4>

      <div
        class="select-organization"
        @click="changeOrganization(org.id)"
        v-for="org in organizations"
        :key="org.id"
      >
        <p>{{ org.attributes.name }}</p>
      </div>
    </div>

    <div v-else class="select-organizations">
      <h4>
        {{ $t("template.you_dont_have_organization") }}
      </h4>

      <div class="tw-flex tw-flex-wrap tw-gap-4 tw-my-[20px]">
        <button
          type="button"
          @click.prevent="openModalAdd()"
          class="bttn bttn--lg bttn--orange"
          name="button"
        >
          {{ $t("account.add_organization") }}
        </button>
        <div class="tw-flex tw-flex-wrap tw-gap-4">
          <button
            type="button"
            @click.prevent="logout()"
            class="bttn bttn--lg bttn--blue bttn--logout"
            name="button"
          >
            {{ $t("template.signout") }}
          </button>
          <button
            v-if="previousRoute !== '/'"
            type="button"
            @click.prevent="() => $router.go(-1)"
            class="bttn bttn--lg bttn--blue"
            name="button"
          >
            {{ $t("template.back") }}
          </button>
        </div>
      </div>

      <add-organization ref="modalAddOrganization"> </add-organization>
    </div>
  </div>
</template>

<script>
import AppSidebar from "@/components/menu.vue";
import { mapState } from "vuex";
import addOrganization from "@/views/account/subcomponents/addOrganization.vue";
import SmartupIframe from "@/components/smartup-iframe.vue";
import myTopCurvedBg from "@/views/donor-dashboard/my-contacts/ui/my-top-curved-bg.vue";

export default {
  name: "home",
  data() {
    return {
      isBurgerOpen: false,
      isDesktop: false,
      previousRoute: null,
    };
  },

  components: {
    AppSidebar,
    addOrganization,
    SmartupIframe,
    myTopCurvedBg,
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$data.previousRoute = from.path;
    });
  },

  computed: mapState({
    loading: (state) => {
      return state.account.loadingAccount;
    },

    needSelectOrg: (state) => {
      return state.account.needSelectOrg;
    },

    loadTranslation: (state) => {
      return state.translation.loadTranslation;
    },

    haveAccount: (state) => {
      return state.account.account;
    },

    loadingAccess: (state) => {
      return state.account.loadingAccess;
    },

    organizations: (state) => {
      return state.account.organizations;
    },

    whitelabel: (state) => (state.account.settings ? state.account.settings.whitelabel : false),

    orgLogo() {
      if (this.whitelabel) {
        return this.haveAccount.data.attributes.logo;
      }
      return false;
    },
  }),

  methods: {
    logout: function () {
      this.$store.dispatch("unsetUser");
      this.$router.push({ path: "/" });
    },

    openModalAdd: function () {
      this.$refs.modalAddOrganization.openModal();
    },

    sidebarToggle() {
      this.isBurgerOpen = !this.isBurgerOpen;
      this.$refs.sidebar.toggleSidebar();
    },

    burgerClose() {
      this.isBurgerOpen = false;
    },

    changeOrganization: function (id) {
      this.$store.dispatch("changeOrganization", id);
    },
  },

  created: function () {
    this.$store.dispatch("getAccountInfo");
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_vars.scss";

.mobile-header {
  height: 90px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $bb-90;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 50;
  @media only screen and (min-width: 1280px) {
    display: none;
  }
  > .logo {
    display: inline-block;
    margin: 0;
    svg {
      width: 150px;
      height: auto;
    }
  }
}

.orgLogo {
  width: 70px;
  border-radius: 50%;
}

.burger {
  width: 24px;
  height: 24px;
  position: fixed;
  top: calc(45px - 9px);
  left: 15px;
  z-index: 150;
  cursor: pointer;
  @media only screen and (min-width: 1280px) {
    display: none;
  }
  &__bar {
    width: 21px;
    height: 4px;
    border-radius: 2px;
    background-color: #ffffff;
    position: relative;
    transition: all 0.2s ease-in-out;
    &:not(:last-of-type) {
      margin-bottom: 3px;
    }
  }
  &.open {
    .burger__bar {
      &:nth-of-type(1) {
        top: 7px;
        transform: rotate(-45deg);
      }
      &:nth-of-type(2) {
        opacity: 0;
        visibility: hidden;
      }
      &:nth-of-type(3) {
        bottom: 7px;
        transform: rotate(45deg);
      }
    }
  }
}

.wrapper-home {
  padding: 120px 15px;
  min-height: 100vh;
  background: url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco1.svg")
      top center no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco2.svg")
      top 0px right -10px no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco3.svg")
      bottom -100px right 0 no-repeat,
    url("https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/charidy_images/donor_dashboard/deco4.svg")
      bottom 100px left 0 no-repeat;
  @media only screen and (min-width: 1280px) {
    padding: 60px 70px 60px 70px;
    margin-left: 300px;
  }
}

.select-organizations {
  width: 80%;
  background: #fff;
  border-radius: 5px;
  padding: 50px;
  box-shadow: 1px 1px 14px -2px rgba(0, 0, 0, 0.15);
  @media only screen and (max-width: 540px) {
    width: 90%;
  }
  .select-organization {
    cursor: pointer;
    border-bottom: 1px solid #e7e7e7;
    padding: 20px 20px 0 20px;
    transition: all 0.5s;
    &:hover {
      border-color: #20434e;
    }
  }
}

.select-organizations-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;

  @media only screen and (min-width: 1280px) {
    margin-left: 300px;
  }
}

.add-organization-wrapp {
  display: flex;
}

.bttn--logout {
  @media screen and (min-width: 1280px) {
    display: none !important;
  }
}
</style>
